import { useQuery } from '@tanstack/react-query'
import { getNearbyPlumbers, getPlumber } from '../lib/api'
import type { Plumber } from '../types'

export function useNearbyPlumbers(postcode: string | undefined, radius?: number) {
  return useQuery<Plumber[]>({
    queryKey: ['plumbers', postcode, radius],
    queryFn: () => getNearbyPlumbers(postcode!, radius),
    enabled: !!postcode,
    staleTime: 5 * 60 * 1000,
  })
}

export function usePlumber(id: string | undefined) {
  return useQuery<Plumber>({
    queryKey: ['plumber', id],
    queryFn: () => getPlumber(id!),
    enabled: !!id,
    staleTime: 10 * 60 * 1000,
  })
}
